import script from "./MarkdownCont.vue?vue&type=script&setup=true&lang=js"
export * from "./MarkdownCont.vue?vue&type=script&setup=true&lang=js"

import "./MarkdownCont.vue?vue&type=style&index=0&id=2a196842&lang=scss"

const __exports__ = script;

export default __exports__